/**
 * SettingsTabContent — Named export consumed by App.tsx for the unified settings panel.
 *
 * `SmsSettingsTabContent` lazy-loads the inner settings page so the settings
 * bundle is NOT part of the main chunk. Mirrors the email app's
 * EmailSettingsTabContent pattern exactly.
 */

import { Skeleton } from "@plerity/ui-core";
import { lazy, Suspense } from "react";

const SmsSettings = lazy(() => import("../sms/SmsSettings"));

export function SmsSettingsTabContent() {
  return (
    <Suspense
      fallback={
        <div className="space-y-4">
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
      }
    >
      <SmsSettings />
    </Suspense>
  );
}
